import { render, staticRenderFns } from "./digitalFlop.vue?vue&type=template&id=2534b986&"
import script from "./digitalFlop.vue?vue&type=script&lang=js&"
export * from "./digitalFlop.vue?vue&type=script&lang=js&"
import style0 from "./digitalFlop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports